import type { LucideIcon } from 'lucide-react'
import { cn } from '../../lib/utils'
import { Button } from './Button'

interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  description?: string
  action?: { label: string; onClick: () => void }
  className?: string
}

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-12 px-4 text-center', className)}>
      {Icon && (
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-surface-tertiary mb-4">
          <Icon className="h-6 w-6 text-content-tertiary" />
        </div>
      )}
      <h3 className="text-base font-semibold text-content-primary">{title}</h3>
      {description && <p className="mt-1 text-sm text-content-secondary max-w-sm">{description}</p>}
      {action && (
        <Button onClick={action.onClick} size="sm" className="mt-4">
          {action.label}
        </Button>
      )}
    </div>
  )
}
